<template>
  <div class="quiz-template">
    <div class="quiz-template1">
      <div
        class="quiz-template1_cell"
        v-for="(option, index) in options"
        v-bind:key="index"
      >
        <div
          :class="['quiz-template1_item', {'quiz-template1_item__disabled': showResult !== null}]"
          v-if="index !== showResult"
          @click="onSelectOption(index, option)"
        >
          <div class="quiz-image_header">{{ option.header }}</div>
          <div class="quiz-image">
            <img class="quiz-image_pic" :src="option.image"/>
          </div>
          <div class="quiz-image_footer">{{ option.footer }}</div>
        </div>
        <template
          class="quiz-template1_item"
          v-else
        >
          <div class="quiz-image" style="opacity: 0">
            <img class="quiz-image_pic" :src="option.image"/>
          </div>
          <Transition name="page-transition" mode="out-in" appear>
            <div
              class="quiz-template1_item quiz-template1_item__correct"
              v-if="option.correct"
            >
              <h3 class="quiz-template1_item-result-heading">Верно!</h3>
              <p class="quiz-template1_item-result-text">{{ resultMessage.correctMessage }}</p>
              <button class="button outlined" @click="gotoNextQuest">{{ $c(lastQuest ? 'К результатам' : 'Следующий вопрос') }}</button>
            </div>
            <div
              class="quiz-template1_item quiz-template1_item__wrong"
              v-else
            >
              <h3 class="quiz-template1_item-result-heading">Не совсем</h3>
              <p class="quiz-template1_item-result-text">{{ resultMessage.wrongMessage }}</p>
              <button class="button outlined" @click="gotoNextQuest">{{ $c(lastQuest ? 'К результатам' : 'Следующий вопрос') }}</button>
            </div>
          </Transition>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {}
})
class QuizTemplate1 extends Vue {
  @Prop({
    required: true,
    type: Object
  }) quizData
  @Prop({
    required: true,
    type: Object
  }) resultMessage
  @Prop({
    required: true,
    type: Boolean
  }) lastQuest

  showResult = null
  selectedOption = null

  get options () {
    return this.quizData.options
  }

  onSelectOption (index, item) {
    if (this.selectedOption) return true
    this.showResult = index
    this.selectedOption = item
  }

  gotoNextQuest () {
    this.$root.$emit('quizNextQuest', this.selectedOption.correct)
    setTimeout(() => {
      this.showResult = null
      this.selectedOption = null
    }, 500)
  }
}
export default QuizTemplate1
</script>

<style lang="scss">
  .quiz-image {
    position: relative;
    display: inline-block;
    width: 100%;
    overflow: hidden;
    &:after {
      content: '';
      position: absolute;
      width: 195%;
      height: 100%;
      left: -30%;
      top: 0;
      background:
        linear-gradient(0deg, rgba(255, 255, 255, 0.00), rgba(255, 255, 255, 0.00)),
        radial-gradient(23.44% 50% at 41.13% 50.13%, rgba(25, 25, 25, 0) 0%, #181818 100%);
      pointer-events: none;
    }
    &_header, &_footer {
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 25px;
      color: #FFFFFF;
      text-align: center;
      position: absolute;
      left: 0;
      width: 100%;
      z-index: 1;
    }
    &_header {
      top: 40px;
    }
    &_footer {
      bottom: 40px;
    }
    &_pic {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }
  .quiz-template1 {
    display: grid;
    @include media_tablet_landscape {
      grid-template-columns: 1fr 1fr 1fr;
      grid-column-gap: 40px;
    }
    &_cell {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    &_item {
      position: relative;
      width: 100%;
      cursor: pointer;
      flex: 1;
      display: flex;
      justify-content: center;
      &__disabled {
        pointer-events: none;
      }
      &:after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        border: 1px solid #666666;
        border-radius: 20px;
        opacity: 0;
        transition: opacity .3s ease;
        background: rgba(#C4C4C4, .015);
        pointer-events: none;
      }
      &:hover {
        &:after {
          opacity: 1;
        }
      }
      &__correct,
      &__wrong {
        padding: 20px;
        box-sizing: border-box;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
        cursor: default;
        &:after {
          content: none;
        }
        .button {
          cursor: pointer;
        }
      }
      &__correct {
        background: #141414;
        border: 2px solid #2A8000;
        color: #3BB200;
      }
      &__wrong {
        background: #141414;
        border: 2px solid #805C0E;
        color: #FDB71B;
      }
      &-result-heading {
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        margin-bottom: 10px;
        @include media_tablet {
          font-size: 30px;
          line-height: 35px;
        }
      }
      &-result-text {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        margin-bottom: 30px;
        @include media_tablet {
          font-size: 20px;
          line-height: 25px;
        }
      }
    }
  }
</style>
